export default {
  done: { id: 'done' },
  completed: { id: 'completed' },
  inProgress: { id: 'in_progress' },
  eventsComplete: { id: 'events_complete' },
  eventsInProgress: { id: 'events_in_progress' },
  eventsDone: { id: 'events_done' },
  dailyLogbookStatus: { id: 'daily_logbook_status' },
  sites: { id: 'sites' },
  siteGroup: { id: 'site_group' },
  of: { id: 'of' },
  allSites: { id: 'all_sites' },
  parameters: { id: 'parameters' },
}
